module.exports = __webpack_public_path__ + "static/media/Ctos_logo_grey.0bc436f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ctos_logo_grey.svg
// module id = 1111
// module chunks = 14